import {
    Dispatch,
    FC,
    ReactNode,
    SetStateAction,
} from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';
import { MapBox } from '../MapBox';
import { MAPBOX_ACCESS_TOKEN } from '../../const/environments.constants';

interface DriversMapProps {
    children: ReactNode;
    setMapsLoaded: Dispatch<SetStateAction<boolean>>;
    center: {
        lat: number;
        lng: number;
    };
    zoom: number;
}

const DriversMap: FC<DriversMapProps> = ({
    children,
    setMapsLoaded,
    center,
    zoom,
}) => (
    <div style={{ width: '100%', height: '100%' }}>
        <MapBox
            center={center}
            zoom={zoom}
            setMapsLoaded={setMapsLoaded}
            apiKey={MAPBOX_ACCESS_TOKEN as string}
        >
            {children}
        </MapBox>
    </div>
);

export { DriversMap };
